import { Theme, makeStyles } from '@material-ui/core';

import styleGuide from 'src/theme/MUI/styleGuide';
import typography from 'src/theme/MUI/typography';

export default makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: '#100b34',
    color: '#ffffff',
    paddingBottom: theme.spacing(8),
  },
  container: {
    padding: ` ${styleGuide.estimate(96, 16)} ${styleGuide.estimate(16, 16)} 0`,
    display: 'block',
    [theme.breakpoints.up('md')]: {
      padding: 0,
      paddingTop: theme.spacing(19),
    },
  },
  mainWrapper: {
    [theme.breakpoints.up('md')]: {
      maxWidth: 'auto',
    },
  },
  mainContent: {
    display: 'flex',
    height: '100%',
    margin: 'auto',
    textAlign: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {},
    marginBottom: 20,
  },
  mainContentHead: {
    textAlign: 'center',
    marginBottom: 16,
    fontWeight: typography.fontWeightBold,
    [theme.breakpoints.up('md')]: {
      whiteSpace: 'pre-line',
      marginLeft: theme.spacing(11.5),
      marginRight: theme.spacing(11.5),
    },
  },
  mainContentText: {
    textAlign: 'center',
    color: '#ffffff',
    whiteSpace: 'pre-line',
    [theme.breakpoints.up('md')]: {
      marginLeft: theme.spacing(17),
      marginRight: theme.spacing(17),
      margin: 'auto',
    },
  },
  mainImg: {
    width: '100%',
    height: 'auto',
    [theme.breakpoints.up('md')]: {
      width: '90%',
    },
  },
  benefitWrapper: {
    alignItems: 'start',
    [theme.breakpoints.up('md')]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: theme.spacing(3),
      marginLeft: theme.spacing(11),
      marginRight: theme.spacing(11),
    },
    [theme.breakpoints.up('lg')]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: `${styleGuide.estimate(74, 16)}`,
      width: '74%',
      maxWidth: `${styleGuide.estimate(1064, 16)}`,
      margin: 'auto',
    },
  },
  benefitItem: {
    display: 'flex',
    marginBottom: 13,
    alignItems: 'flex-start',
  },
  imgItemWrapper: {
    width: 33.33,
    height: 30.83,
    display: 'flex',
    justifyContent: 'center',
    alignItem: 'center',
    marginBottom: 13,
  },
  titleItem: {
    fontWeight: typography.fontWeightBold,
  },
  smallTitleItem: {
    marginBottom: 8,
  },
  contentItem: {
    marginBottom: 30,
    [theme.breakpoints.up('md')]: {
      width: 'auto',
    },
  },
  imgBottom: {
    width: '100%',
    height: 'auto',
  },
}));
